import { CHECKMEPRO_CRC } from "../BleContstants";

export function crc8(buf:any):any{

  let crc = 0;

  for (let i = 0; i < buf.length; i++)
    crc = CHECKMEPRO_CRC[(crc ^ buf[i]) % 256]

  return crc;
}

export function unpack(str) {
  const bytes = [];
  for(let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      bytes.push(char >>> 8);
      bytes.push(char & 0xFF);
  }
  return bytes;
}

export function getFileName (item :Date):string
{
     const value =  item.getFullYear().toString() +
(item.getMonth() +1).toString().padStart(2,'0') +
 item.getDate().toString().toString().padStart(2,'0')  +
 item.getHours().toString().toString().padStart(2,'0')   +
 item.getMinutes().toString().toString().padStart(2,'0')   +
 item.getSeconds().toString().toString().padStart(2,'0')
 return value
}



export function  decodeString (data:number[],start:number,size:number):string{

  const stringbyte = []
  for ( let i=0;i < size;i++)
  {
    if (data[i+start] != 0)
    {
      stringbyte.push(data[i+start])
    }
  }



  const str = String.fromCharCode(...stringbyte);
  return str

}

const delay = (delayInms) => {
  return new Promise((resolve) => setTimeout(resolve, delayInms));
};


export  async function safeWrite (WriteCharacteristic :BluetoothRemoteGATTCharacteristic ,data: Int8Array )
{

  WriteCharacteristic.writeValue(data).catch(() => {
    console.log("DOMException: GATT operation already in progress.");
    return Promise.resolve()
      .then(() => delay(1500))
      .then(() => {
        WriteCharacteristic.writeValue(data);
      });
  });

}

